import { useCallback } from 'react'
import useFormatMoney from './useFormatMoney'
import useShouldHideCents from './useShouldHideCents'

/**
 * Money formatter for bet values. Unlike `useFormatMoney` (which hides cents
 * only on the global `currencyHideCents` flag), this applies the bet
 * visibility rule per amount: cents are hidden when the value is above the
 * configured limit and lands on a `hideCentsWhenMultipleOf` multiple. Use it
 * for bet options, bet steppers and other bet-derived amounts.
 */
const useFormatBetMoney = () => {
    const formatMoney = useFormatMoney()
    const shouldHideCents = useShouldHideCents()

    return useCallback((amount: number) => formatMoney(amount, shouldHideCents(amount)), [formatMoney, shouldHideCents])
}

export default useFormatBetMoney
